import * as React from "react";
import {
  Box,
  Typography,
  Paper,
  Grid,
  TextField,
  Button,
  CardContent,
  Select,
  MenuItem,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useParams } from "react-router-dom";
import { message } from "antd";

const UpdateTeacher = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { id } = useParams();
  const [name, setName] = React.useState("");
  const [branch_id, setBranch_id] = React.useState("");
  const [gender, setGender] = React.useState("");
  const [phone_number, setPhone_number] = React.useState("");
  const [base_salary, setBase_salary] = React.useState("");
  // const [base_lectures_count, setBase_lectures_count] = React.useState("");
  const token = localStorage.getItem("token");
  React.useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://api.clever-school.com/api/teachers/${id}`,
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (isMounted) {
          const userData = response.data;
          setName(userData.name || "");
          setBranch_id(userData.branch_id || "");
          setPhone_number(userData.phone_number || "");
          setGender(userData.gender || "");
          setBase_salary(userData.base_salary || "");
          // setBase_lectures_count(userData.base_lectures_count || "");
        }
      } catch (error) {
        console.error("Error fetching teacher data:", error);
        message.error(t("error.fetchingData"));
      }
    };

    fetchData();
    return () => {
      isMounted = false;
    };
  }, [id, t, token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const updatedValues = {
        branch_id,
        name,
        phone_number,
        gender,
        base_salary,
        // base_lectures_count,
      };

      await axios.put(
        `https://api.clever-school.com/api/teachers/${id}`,
        updatedValues,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      message.success(t("success.update"));
      window.location.href = "/GetTeacher";
    } catch (error) {
      console.error("Update error:", error);
      message.error(t("error.update"));
    }
  };
  const [userRole, setUserRole] = React.useState("");
  // eslint-disable-next-line no-unused-vars
  const [userBranch, setUserBranch] = React.useState("");
  React.useEffect(() => {
    const userData = localStorage.getItem("user");
    if (userData) {
      try {
        const user = JSON.parse(userData);
        setUserRole(user.role);
        setUserBranch(user.branch_id);

        // Set branch_id automatically for non-superadmins
        if (user.role !== "superadmin") {
          setBranch_id(user.branch_id);
        }
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    }
  }, []);
  const formFieldStyles = {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#f5f5f5",
      borderRadius: "8px",
      "& fieldset": { border: "none" },
      "&:hover fieldset": { border: "none" },
      "&.Mui-focused fieldset": {
        border: "none",
        boxShadow: "0 0 0 2px rgba(25, 118, 210, 0.2)",
      },
    },
    "& .MuiInputBase-input": {
      padding: "12px 14px",
    },
  };

  const formSelect = {
    backgroundColor: "#f5f5f5",
    borderRadius: "8px",
    "& fieldset": { border: "none" },
    "&:hover fieldset": { border: "none" },
    "&.Mui-focused fieldset": {
      border: "none",
      boxShadow: "0 0 0 2px rgba(25, 118, 210, 0.2)",
    },
    "& .MuiInputBase-input": {
      padding: "12px 14px",
    },
  };

  return (
    <Box
      sx={{
        maxWidth: 1200,
        margin: "40px auto",
        padding: theme.spacing(3),
        [theme.breakpoints.down("sm")]: { padding: theme.spacing(2) },
      }}
    >
      <Paper
        elevation={2}
        sx={{
          borderRadius: 4,
          padding: theme.spacing(4),
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <Box component="form" onSubmit={handleSubmit}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 500, mb: 3 }}>
            {t("Updateteacher")}
          </Typography>
          <Grid container spacing={3}>
            {/* Name Field */}
            <Grid item xs={12} md={6}>
              <CardContent>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  gutterBottom
                >
                  {t("name")}
                </Typography>
                <TextField
                  fullWidth
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder={t("enterName")}
                  variant="outlined"
                  required
                  sx={formFieldStyles}
                />
              </CardContent>
            </Grid>

            {/* Gender Field */}
            <Grid item xs={12} md={6}>
              <CardContent>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  gutterBottom
                >
                  {t("Gender")}
                </Typography>
                <Select
                  fullWidth
                  value={gender}
                  onChange={(e) => setGender(e.target.value)}
                  variant="outlined"
                  displayEmpty
                  required
                  sx={formSelect}
                >
                  <MenuItem value="" disabled>
                    {t("selectGender")}
                  </MenuItem>
                  <MenuItem value="M">{t("Male")}</MenuItem>
                  <MenuItem value="F">{t("Female")}</MenuItem>
                </Select>
              </CardContent>
            </Grid>
            {/* branch_id Field */}
            {userRole === "superadmin" && (
              <Grid item xs={12} md={6}>
                <CardContent>
                  <Typography
                    variant="subtitle2"
                    color="textSecondary"
                    gutterBottom
                  >
                    {t("Branch")}
                  </Typography>
                  <Select
                    fullWidth
                    value={branch_id}
                    onChange={(e) => setBranch_id(e.target.value)}
                    variant="outlined"
                    displayEmpty
                    required
                    sx={formSelect}
                  >
                    <MenuItem value="" disabled>
                      {t("selectBranch")}
                    </MenuItem>
                    <MenuItem value={1}>{t("Nursery")}</MenuItem>
                    <MenuItem value={2}>{t("Primary School")}</MenuItem>
                    <MenuItem value={3}>{t("Secondary School")}</MenuItem>
                  </Select>
                </CardContent>
              </Grid>
            )}
            {/* Phone Number Field */}
            <Grid item xs={12} md={6}>
              <CardContent>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  gutterBottom
                >
                  {t("phoneNumber")}
                </Typography>
                <TextField
                  fullWidth
                  value={phone_number}
                  onChange={(e) => setPhone_number(e.target.value)}
                  placeholder={t("enterPhone")}
                  variant="outlined"
                  required
                  sx={formFieldStyles}
                />
              </CardContent>
            </Grid>

            {/* Base Salary Field */}
            <Grid item xs={12} md={6}>
              <CardContent>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  gutterBottom
                >
                  {t("base salary")}
                </Typography>
                <TextField
                  fullWidth
                  type="number"
                  value={base_salary}
                  onChange={(e) => setBase_salary(e.target.value)}
                  placeholder={t("enterClass")}
                  variant="outlined"
                  required
                  sx={formFieldStyles}
                />
              </CardContent>
            </Grid>

            {/* Lectures Count Field */}
            {/* <Grid item xs={12} md={6}>
              <CardContent>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  gutterBottom
                >
                  {t("base lectures count")}
                </Typography>
                <TextField
                  fullWidth
                  type="number"
                  value={base_lectures_count}
                  onChange={(e) => setBase_lectures_count(e.target.value)}
                  placeholder={t("enterClass")}
                  variant="outlined"
                  required
                  sx={formFieldStyles}
                />
              </CardContent>
            </Grid> */}

            {/* Buttons */}
            <Grid item xs={12}>
              <Box
                sx={{
                  mt: 4,
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 2,
                }}
              >
                <Button
                  variant="outlined"
                  onClick={() => (window.location.href = "/GetTeacher")}
                  sx={{
                    px: 4,
                    borderRadius: 2,
                    textTransform: "none",
                    color: theme.palette.error.main,
                    borderColor: theme.palette.error.main,
                  }}
                >
                  {t("cancel")}
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    px: 6,
                    borderRadius: 2,
                    textTransform: "none",
                    backgroundColor: theme.palette.success.main,
                    "&:hover": {
                      backgroundColor: theme.palette.success.dark,
                    },
                  }}
                >
                  {t("update")}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Box>
  );
};

export default UpdateTeacher;
